import {TranslationObject} from '@colonist/i18n'
import {useGameStore} from '../store/GameStoreContext'
import {clamp} from '@colonist/utils'
// eslint-disable-next-line no-restricted-imports
import {notificationController} from '../../../../code/client/shared/scripts/EntryShared'
import {LobbyImage} from '@colonist/types'
// eslint-disable-next-line no-restricted-imports
import {NotificationContentType} from '../../../../code/client/shared/scripts/ui_utils/NotificationUtils'
import {useCallback} from 'react'
import {useHotkeys} from 'react-hotkeys-hook'
import {StorageWrapper} from '../utils/storage'
// eslint-disable-next-line no-restricted-imports
import {Sound} from '../../../../code/client/shared/scripts/Sound'

export const useGameUserSettingsSetVolume = () => {
    const setVolume = useGameStore((state) => state.gameUserSettings.setVolume)

    const setVolumeWithClamp = useCallback((newVolume: number, showNotification = false) => {
        const clampedVolume = clamp(newVolume, 0, 1)
        setVolume(clampedVolume)
        Sound.setMasterVolume(clampedVolume)

        if(showNotification) {
            const volumeDisplayLevel = Math.round(clampedVolume * 100)
            const masterVolumeChangedText: TranslationObject = {
                key: 'strings:game.settings.shortcutPopups.volumeLevel',
                options: {count: volumeDisplayLevel},
            }
            notificationController.showNotification(LobbyImage.Audio,
                masterVolumeChangedText,
                2500,
                undefined,
                undefined,
                NotificationContentType.Volume)
        }
    }, [setVolume])

    return setVolumeWithClamp
}

export const useGameUserSettingsToggleMuteVolume = () => {
    const volume = useGameStore((state) => state.gameUserSettings.volume)
    const setVolume = useGameUserSettingsSetVolume()

    const toggleMuteVolume = useCallback((showNotification: boolean) => {
        const newLevel = volume > 0 ? 0 : 1
        setVolume(newLevel)

        if(showNotification) {
            const mutedText: TranslationObject = newLevel > 0 ?
                {key: 'strings:game.settings.shortcutPopups.soundUnmuted'}
                : {key: 'strings:game.settings.shortcutPopups.soundMuted'}
            notificationController.showNotification(LobbyImage.Audio, mutedText)
        }
    }, [volume, setVolume])

    return toggleMuteVolume
}

export const useGameUserSettingsVolumeHotkeys = () => {
    const volume = useGameStore((state) => state.gameUserSettings.volume)
    const setVolumeWithClamp = useGameUserSettingsSetVolume()
    const toggleMuteVolume = useGameUserSettingsToggleMuteVolume()

    const VOLUME_INCREMENT = 0.1
    useHotkeys('ArrowUp', () => {
        if(!StorageWrapper.getKeyboardShortcuts()) return
        setVolumeWithClamp(volume + VOLUME_INCREMENT, true)
    })
    useHotkeys('ArrowDown', () => {
        if(!StorageWrapper.getKeyboardShortcuts()) return
        setVolumeWithClamp(volume - VOLUME_INCREMENT, true)
    })
    useHotkeys('m', () => {
        if(!StorageWrapper.getKeyboardShortcuts()) return
        toggleMuteVolume(true)
    })
}
